/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class WorkTypeRenderer
 *
 * @brief cell rendering for the workblock type
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkTypeRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: any;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">Type...</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    if ((typeof params.value === 'object') && (params.value !== null)) {

      this.value = params.value.name;

    } else {

      this.value = params?.value;
    }

    if (this.value) {

      this.gui.innerHTML = `<span style="font-weight: bold;">${this.value}</span>`;
    }

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
